/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomField } from '../../model/customfieldsresponse';
declare var $: any;

@Component({
  selector: 'zsd-hyperlinkfield',
  templateUrl: '../../view/customfields/hyperlinkfield.component.html',
  styleUrls: ['../../view/customfields/customfields.component.scss']
})
export class HyperlinkFieldComponent implements OnInit {

  @Input('parentForm') public parentForm: FormGroup;
  @Input() customField: CustomField;
  @Input('fromQuickCall') public fromQuickCall: boolean;


  customValidators = [];

  hyperlinkCustomForm: FormGroup;

  constructor(public formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.hyperlinkCustomForm = this.formBuilder.group({
      data: this.formBuilder.control({ value: null, disabled: (this.customField.clientEditable ? false : true) }),
    });

    if (this.customField.defaultValue) {
      this.hyperlinkCustomForm.get('data').setValue(this.customField.defaultValue);
    }
  if (this.customField.required === 1) {
      this.customValidators.push(Validators.required);
    }

    this.hyperlinkCustomForm.get('data').setValidators(this.customValidators);
    this.hyperlinkCustomForm.updateValueAndValidity();

    this.parentForm.addControl(this.customField.fieldId + '', this.hyperlinkCustomForm);
    this.parentForm.setControl(this.customField.fieldId + '', this.hyperlinkCustomForm);

    // Setup for description jquery
    if (this.customField.dscEnable === 1) {
      $(document).ready(function () {
        $('[data-toggle=' + this.customField.fieldId + ']').popover();
      }.bind(this));
    }

  }

}
